import { apiPublic } from "./apiPublic.service";

const API_URL = "/ranking";

class RankingService {
    /**
     * Récupère le top 10 général ou filtré (par région, département, commune)
     */
    async getTopUsers(filters = {}) {
        try {
            const response = await apiPublic.get(`${API_URL}/top`, { params: filters });
            return response.data;
        } catch (error) {
            console.error("Erreur lors de la récupération du classement :", error);
            throw error;
        }
    }

    /**
     * Récupère le rang global d'un utilisateur
     */
    async getGlobalRank(userId) {
        try {
            const response = await apiPublic.get(`${API_URL}/global-rank/${userId}`);
            // Renvoi formaté pour le front
            return response.data.rank
                ? { position: response.data.rank.position, total: response.data.rank.total }
                : null;
        } catch (error) {
            console.error("Erreur lors de la récupération du rang global :", error);
            return null;
        }
    }

    /**
     * Récupère le rang régional d'un utilisateur
     */
    async getRegionalRank(userId) {
        try {
            const response = await apiPublic.get(`${API_URL}/regional-rank/${userId}`);
            if (!response.data.rank) return null;

            return {
                position: response.data.rank.position,
                total: response.data.rank.total,
                regionName: response.data.region.name || "—"
            };
        } catch (error) {
            console.error("Erreur lors de la récupération du rang régional :", error);
            return null;
        }
    }

    /**
     * Récupère le rang départemental d'un utilisateur
     */
    async getDepartmentRank(userId) {
        try {
            const response = await apiPublic.get(`${API_URL}/department-rank/${userId}`);
            if (!response.data.rank) return null;

            return {
                position: response.data.rank.position,
                total: response.data.rank.total,
                departmentName: response.data.department.name || "—"
            };
        } catch (error) {
            console.error("Erreur lors de la récupération du rang départemental :", error);
            return null;
        }
    }

    /**
     * Récupère le rang communal d'un utilisateur
     */
    async getCityRank(userId) {
        try {
            const response = await apiPublic.get(`${API_URL}/city-rank/${userId}`);
            if (!response.data.rank) return null;

            return {
                position: response.data.rank.position,
                total: response.data.rank.total,
                cityName: response.data.city.name || "—"
            };
        } catch (error) {
            console.error("Erreur lors de la récupération du rang communal :", error);
            return null;
        }
    }

    /**
     * 🔥 Récupère les 4 rangs d’un coup (super pratique pour un dashboard)
     */
    async getAllRanks(userId) {
        try {
            const [general, regional, departmental, city] = await Promise.all([
                this.getGlobalRank(userId),
                this.getRegionalRank(userId),
                this.getDepartmentRank(userId),
                this.getCityRank(userId)
            ]);

            return { general, regional, departmental, city };
        } catch (error) {
            console.error("Erreur lors de la récupération des rangs :", error);
            throw error;
        }
    }

    /**
     * 🔮 Classement simulé (sans user)
     * @param {Object} params
     * @param {number} params.amount (obligatoire)
     * @param {string} [params.regionId]
     * @param {number} [params.departmentId]
     * @param {number} [params.cityId]
     */
    async getSimulatedRank(params) {
        try {
            const response = await apiPublic.get(`${API_URL}/simulate`, {
                params
            });

            return {
                amount: response.data.amount,
                position: response.data.position,
                total: response.data.total
            };
        } catch (error) {
            console.error("Erreur lors de la récupération du classement simulé :", error);
            return null;
        }
    }
}

export default new RankingService();
